document.addEventListener('DOMContentLoaded', function() {
  // add swiper on the studio page
  initSwiperOnStudioPage();
  initSwiperOnCartPage();
  initSwiperOnLandingPage();
  initSwatchIcons();
  initSwiperOnBanners();
  initFeaturedProductstSwiper();
  initStudioSlider();
  initTestimonialSlider();
  invisibleArticleSlider();
  copyCoords();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    if (document.querySelector('[data-track-enabled="true"]')) copyCoords()
  });
}

function initSwiperOnCartPage() {
  const swiperItems = document.querySelectorAll('.recommendations-products-swiper');
  swiperItems.forEach(item => {
    new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      }
    });
  });
}

function initFeaturedProductstSwiper() {
  if (window.innerWidth < 768) {
    const swiperItems = document.querySelectorAll('.featured-list__items-swiper');
    swiperItems.forEach(item => {
      new Swiper(item, {
        slidesPerView: 1.2,
        spaceBetween: 18,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      })
    });
  }
}

function initSwiperOnStudioPage() {
  const swiperItems = document.querySelectorAll('[js-banner-swiper]');
  swiperItems.forEach(item => {
    new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });
  });
}

function initStudioSlider() {
  const swiperItems = document.querySelectorAll('.studio-swiper');
  swiperItems.forEach(item => {
    new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 35,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 4.2,
          spaceBetween: 28,
        }
      }
    });
  });
}

function initTestimonialSlider() {
  let swiperElement = document.querySelector('.testimonial-slider__slider');
  if (swiperElement) {
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 60
        }
      }
    });
  }
}

function initSwiperOnBanners() {
  const bannerItems = document.querySelectorAll('[js-homepage-hero-banner]');
  const keyItems = document.querySelectorAll('.home-hero-banner__key-item');

  let swiperItems = [];

  bannerItems.forEach(item => {
    const sectionId = item.getAttribute('data-section-id');
    const loopTime = Number(item.getAttribute('data-loop-time')) * 1000;
    const swiperItem = new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: "fade",
      autoplay: {
        enabled: loopTime === 0 ? false: true,
        delay: loopTime,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });

    swiperItem.on('slideChange', (e) => {
      let activeIndex = -1;
      document.querySelectorAll('.home-hero-banner__wrapper .swiper-wrapper .home-hero-banner__item').forEach((item, index) => {
        if (e.realIndex === index) {
          activeIndex = item.getAttribute('data-index');
        }
      });

      keyItems.forEach((keyItem, index) => {
        if (Number(keyItem.getAttribute("data-key-idx")) == e.realIndex ) {
          keyItem.classList.add('active');
        } else {
          keyItem.classList.remove('active');
        }
      })
    });

    const bannerElement = item.parentNode;
    bannerElement.addEventListener('mouseenter', () => {
      swiperItem.autoplay.stop();
    });

    bannerElement.addEventListener('mouseleave', () => {
      if (loopTime > 0) {
        swiperItem.autoplay.start();
      }
    });

    bannerElement.addEventListener('click', () => {
      swiperItem.autoplay.stop();
    });

    swiperItems.push({
      sectionId: sectionId,
      swiper: swiperItem
    })

    keyItems.forEach((keyItem, idx) => {
      keyItem.addEventListener('click', (e) => {
        e.preventDefault();
        const paginations = item.querySelectorAll('.swiper-pagination .swiper-pagination-bullet');
        paginations.forEach((bullet, pIdx) => {
          if (pIdx == Number(keyItem.getAttribute("data-key-idx"))) {
            bullet.click();
          }
        });
      });
    });
  });
}

function initSwatchIcons() {
  if (document.getElementById('product-json')) {
    const product = JSON.parse(document.getElementById('product-json').innerHTML);

    const swatchElement = document.querySelector('.swatch.product-form__item');
    const sizeElement = document.querySelector('.selector.product-form__item select');

    if (swatchElement) {
      const optionIdx = swatchElement.getAttribute('data-option-index');
      const option_label = 'option' + optionIdx;
      const option2_label = sizeElement.getAttribute('data-index');

      const options = swatchElement.querySelectorAll('.single-option-selector');
      options.forEach(option => {
        option.addEventListener('click', (e) => {
          sizeElement.value = -1; // init size value;
          changeVariantId("-1", product);

          const option_value = option.value;
          product.variants.forEach(variant => {
            if (variant[option_label] === option_value) {
              //sizeVariant.value = variant.id;
              sizeElement.querySelectorAll('option').forEach(sizeOption => {
                if (sizeOption.value == variant[option2_label]) {
                  if (variant.available)
                    sizeOption.disabled = false;
                  else
                    sizeOption.disabled = true;
                }
              });
            }
          });
        });
      });
    }

    if (sizeElement) {
      sizeElement.addEventListener('change', (e) => {
        changeVariantId(e.target.value, product);
      });
    }
  }
}

function changeVariantId (option2_value, product) {
  const variant_input = document.querySelector('.product__info input[data-variant-id]');
  if (option2_value === "-1") { // init value
    variant_input.value = "";
    return;
  }

  let option1 = '', variant_title = '';
  if (document.querySelector('.swatch.product-form__item .swatch-element input[type="radio"]:checked')) {
    option1 = document.querySelector('.swatch.product-form__item .swatch-element input[type="radio"]:checked').value;
  }
  const option2 = option2_value;
  if (option1 !== '') {
    variant_title = `${option1} / ${option2}`;
  } else {
    variant_title = `${option2}`;
  }

  product.variants.forEach(variant => {
    if (variant.title == variant_title) {
      changePriceAndSkuVariant(variant);
      if (variant_input) {
        variant_input.value = variant.id;
      }
    }
  });
}

function changePriceAndSkuVariant(variant) {
  const priceEl = document.querySelector('.product .product__info .product__price');
  const skuEl = document.querySelector('.product .product__info .product__barcode');

  if (priceEl) {
    if (variant.compare_at_price > variant.price) {
      const html = `
        ${Shopify.formatMoney(variant.price, window.moneyFormat)}
        <s>${Shopify.formatMoney(variant.compare_at_price, window.moneyFormat)}</s>
      `;
      priceEl.innerHTML = html;
    } else {
      const html = `
        ${Shopify.formatMoney(variant.price, window.moneyFormat)}
      `;
      priceEl.innerHTML = html;
    }
  }

  if (skuEl) {
    skuEl.innerHTML = `Product code ${variant.sku}`;
  }
}

function initSwiperOnLandingPage() {
const swiperItems = document.querySelectorAll('[js-slideshow-collection]');
  swiperItems.forEach(item => {
    const swiper = new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        '991': {
          slidesPerView: 1.5,
          spaceBetween: 0
        }
      }
    });

    swiper.on('slideChange', (e) => {
      console.log('e = ', e.realIndex);

      const titles = item.parentNode.querySelectorAll('.slideshow-collection__top .slideshow-collection__heading');
      titles.forEach((title, idx) => {
        if (e.realIndex == idx) {
          title.classList.add('active');
        } else {
          title.classList.remove('active');
        }
      });
    })
  });
}

function herobannerEvents() {
  const keyItems = document.querySelectorAll('.home-hero-banner__key-item');
  const heroItems = document.querySelectorAll('.home-hero-banner__item');
  keyItems.forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const sectionId = item.getAttribute('data-section-id');
      const key = item.getAttribute('data-value');

      keyItems.forEach(rItem => {
        rItem.classList.remove('active');
      });

      heroItems.forEach(rItem => {
        rItem.classList.remove('active');
      });

      item.classList.add('active');
      heroItems.forEach(heroItem => {
        const heroSectionId = heroItem.getAttribute('data-section-id');
        const heroKeyId = heroItem.getAttribute('data-value');

        if (sectionId === heroSectionId && heroKeyId === key) {
          heroItem.classList.add('active');
        }
      });
    })
  });
}

/**
 * Initialize invisible article slider.
 */
function invisibleArticleSlider() {
  const sliderWrapper = document.querySelector('[js-article-slider="container"]')
  const letters = document.querySelectorAll('[js-article-slider="letter"]');
  const slides = document.querySelectorAll('[js-article-slider="slide"]');

  if (!sliderWrapper) return;

  const swiper = new Swiper(sliderWrapper, {
    autoHeight: true,
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChangeTransitionStart: () => {
        const activeSlide = slides[swiper.realIndex];
        const activeLetter = activeSlide?.dataset?.letter;
        scrollToTopBlock();

        letters.forEach((el) => {
          el.classList.toggle('is-active', el.dataset.letter === activeLetter);
        });
      }
    }
  });

  sliderToContent(swiper);
}

/**
 * Slide slider to the corresponded slider
 * @param {Object} swiper - Swiper slide object.
 */
function sliderToContent(swiper) {
  const letters = document.querySelectorAll('[js-article-slider="letter"]');
  if (!letters.length) return;

  const goToLetter = (letter) => {
    const target = swiper.el.querySelector(
      `.swiper-slide[data-letter="${letter}"]:not(.swiper-slide-duplicate)`
    );
    if (!target) return;

    const realIndex = Number(target.dataset.swiperSlideIndex);
    if (Number.isNaN(realIndex)) return;

    const slideMethod = swiper.params.loop ? 'slideToLoop' : 'slideTo';
    swiper[slideMethod](realIndex, 0, false);
  };

  letters.forEach((btn) => {
    btn.addEventListener('click', () => {
      scrollToTopBlock?.();

      letters.forEach((el) => el.classList.remove('is-active'));
      btn.classList.add('is-active');

      goToLetter(btn.dataset.letter);
    });
  });
}

/**
 * Scroll page to the top of the slider content block.
 */
function scrollToTopBlock() {
  const sliderWrapper = document.querySelector('[js-article-slider="container"]')

  const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  window.scrollTo({
    top: sliderWrapper.getBoundingClientRect().top + window.scrollY - headerHeight,
    behavior: 'smooth'
  });
}

/**
 * Copy coords from invisible article image viewport based on mouse cursor.
 */
function copyCoords() {
  if (!window.interactiveClickTracking) return;
  const el = document.querySelector('[js-article-slider="image"]');
  if (!el) return;

  el.classList.add('tracking-enabled');

  const inEditor = !!(window.Shopify && Shopify.designMode);
  const fmt = n => (n >= 100 ? '100' : String(Math.max(0, Math.min(100, n))).padStart(2, '0'));
  const copy = t => inEditor
    ? (() => { try {
      const i = Object.assign(document.createElement('input'), { value: t, style: 'position:fixed;left:-9999px' });
      document.body.append(i); i.select();
      if (!document.execCommand('copy')) throw 0; i.remove();
    } catch { prompt('Copy coordinates:', t); } })()
    : navigator.clipboard?.writeText(t).catch(() => {
      const i = Object.assign(document.createElement('input'), { value: t, style: 'position:fixed;left:-9999px' });
      document.body.append(i); i.select(); document.execCommand('copy'); i.remove();
    });

  el.addEventListener('click', e => {
    const r = el.getBoundingClientRect();
    const x = Math.round(((e.clientX - r.left) / r.width) * 100);
    const y = Math.round(((e.clientY - r.top) / r.height) * 100);
    const txt = `${fmt(y)}, ${fmt(x)}`;
    copy(txt);
  });
}

/**
 * Inject styling for form under shadow DOM.
 */
(function initShadowForm() {
  const WRAP_SELECTOR = '[js-form-block="form-block"] #app-embed'; // or [data-js-form-block="form-block"]

  function whenAvailable(selector, timeout = 15000) {
    return new Promise((resolve, reject) => {
      const now = document.querySelector(selector);
      if (now) return resolve(now);

      const mo = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) { mo.disconnect(); resolve(el); }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });

      setTimeout(() => { mo.disconnect(); reject(new Error('timeout')); }, timeout);
    });
  }

  function ensureShadowReady(host, cb) {
    if (host.shadowRoot) return cb(host.shadowRoot);
    const mo = new MutationObserver(() => {
      if (host.shadowRoot) { mo.disconnect(); cb(host.shadowRoot); }
    });
    mo.observe(host, { childList: true });
  }

  function applyClassesAndCSS(sr) {
    sr.querySelectorAll('input:not(.studio-richtext__input), textarea:not(.studio-richtext__input), select:not(.studio-richtext__input)')
      .forEach(el => el.classList.add('studio-richtext__input'));

    if (!sr.querySelector('link[data-wl-shadow-style]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.media = 'all';
      link.href = window.shadowFormStyles;
      link.setAttribute('data-wl-shadow-style', '');
      sr.appendChild(link);
    }
  }

  whenAvailable(WRAP_SELECTOR).then(host => {
    ensureShadowReady(host, (sr) => {
      applyClassesAndCSS(sr);
      const innerMO = new MutationObserver(() => applyClassesAndCSS(sr));
      innerMO.observe(sr, { childList: true, subtree: true });

      const outerMO = new MutationObserver(() => {
        if (!document.contains(host)) {
          innerMO.disconnect(); outerMO.disconnect(); initShadowForm();
        }
      });
      outerMO.observe(document.body, { childList: true, subtree: true });
    });
  }).catch(() => {
    setTimeout(initShadowForm, 2000);
  });
})();

Shopify.queryParams = {};
  if(location.search.length) {
    for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  if (document.querySelector('.sort-by')) {
    document.querySelector('.sort-by').addEventListener('change', function(e) {
      var value = e.currentTarget.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  }
